import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import { Paper } from '@material-ui/core';
import './configuration.less';
import ConfigureGroupServiceType from './ConfigureGroupServiceType';
import ServiceTypeEmailMappings from './ServiceTypeEmailMapping';
import CreateReimbursement from './CreateReimbursement';
import ConfigureWidget from './ConfigureWidget';
import GroupWidgetMapping from './GroupWidgetMapping';
import DesignationThreshold from './DesignationThreshold';
import GroupSectionPermission from './GroupSectionPermission';
import { IsSectionVisible, IsBillingAccountingTabVisible } from '../../utils/helper';
import { SECTIONS } from '../../constants/appConstants';
import ConfigureGroupMarket from './ConfigureGroupMarket';
import ServiceTypeAndPayCode from './ServiceTypeAndPayCode';
import ConfigurePropertyAccountingPayroll from './ConfigurePropertyAccountingPayroll';
import ConfigureDatacenterPayroll from './ConfigureDatacenterPayroll';
import ConfigureSDCBudgetedPercentEmployee from './ConfigureSDCBudgetedPercentEmployee';
import ConfigureSdcEmployeeDesignationPmaTitle from './ConfigureSdcEmployeeDesignationPmaTitle';
import ConfigureDatacenterPropertySplit from './ConfigureDatacenterPropertySplit';
import ConfigureDatacenterEmployeeBonusPercent from './ConfigureDatacenterEmployeeBonusPercent';
import ConfigureBonusAgainstDesignations from './ConfigureBonusAgainstDesignations';
import ConfigureOvertimeTimesheet from './ConfigureOvertimeTimesheet';
import ConfigurationARAdminPropertyMapping from './ConfigurationARAdminPropertyMapping';
import { apiBatchRequest } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import { ShowToast, toastType } from '../../utils/toast-service';
import ConfigureExpenseGroupAndPayCodes from './ConfigureExpenseGroupAndPayCodes';
import ConfigureEmployeeTitle from './ConfigureEmployeeTitle';
import ConfigurationContactRoles from './ConfigurationContactRole';
import ConfigurationRefreshCache from './ConfigurationRefreshCache';
export default class Configurations extends React.Component {
  // Constructor to set initial state of the component
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      tabs: [],
      selectedMenu: 0,
      children: '',
      dataCenterTabs: [],
      yearEndBonusTabs: [],
      accessPermissionTerms: []
    };
  }

  // Get API data before components are mounted
  componentDidMount() {
    this.setConfigurations();
    this.myRef.current.scrollTo(0, 0);
    this.GetAccessPermissionTerms();
  }

  // Get Access Permission data
  GetAccessPermissionTerms = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Users.GetAccessPermissionTerms,
        key: 'accessPermissionTerms'
      }
    ])
      .then(
        ({
          accessPermissionTerms
        }) => {
          this._asyncRequest = null;
          if (accessPermissionTerms.success !== true) {
            ShowToast(
              'Something went wrong',
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          this.setState({
            accessPermissionTerms: accessPermissionTerms.data || []
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Set Configurations
  setConfigurations() {
    const tabs = []; const dataCenterTabs = []; const yearEndBonusTabs = [];

    if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_SERVICE_TYPE_NOTIFICATION)) {
      tabs.push({ id: 1, name: 'Configure Service Type and Email Notification Settings', children: <ServiceTypeEmailMappings /> });
    }
    if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_SERVICE_TYPE_DEPARTMENT)) {
      tabs.push({ id: 2, name: 'Configure Service Type and Department', children: <ConfigureGroupServiceType /> });
    }
    if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_BURDEN_RATE)) {
      tabs.push({ id: 3, name: 'Configure Burden Rate', children: <CreateReimbursement /> });
    }
    if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_DESIGNATION_THRESHOLD_VARIANCE)) {
      tabs.push({ id: 4, name: 'Configure Account Code Name And Threshold Variance', children: <DesignationThreshold /> });
    }
    if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_GROUP_ACCESS_PERMISSION)) {
      tabs.push({ id: 7, name: 'Configure Group Access Permissions', children: <GroupSectionPermission /> });
    }
    if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_USER_MARKET_PERMISSION)) {
      tabs.push({ id: 8, name: 'Configure Market Access Permissions', children: <ConfigureGroupMarket /> });
    }
    if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_SERVICE_TYPE_PAYCODE)) {
      tabs.push({ id: 9, name: 'Configure Service Type and Pay Code', children: <ServiceTypeAndPayCode /> });
    }
    if ((IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_PROPERTY_ACCOUNTING_PAYROLL))) {
      tabs.push({ id: 10, name: 'Configure Property Accounting And Centralized AR Payroll Info', children: <ConfigurePropertyAccountingPayroll /> });
    }
    if (IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_LEADERSHIP_EMPLOYEE)) {
      dataCenterTabs.push({ id: 11, name: 'Configure Datacenter Leadership Employee ', children: <ConfigureSDCBudgetedPercentEmployee /> });
    }
    if (IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_DESIGNATION_PMA_TITLE)) {
      // dataCenterTabs.push({ id: 12, name: 'Configure SDC Employee Designation And PMA Title', children: <ConfigureSdcEmployeeDesignationPmaTitle /> });
      dataCenterTabs.push({ id: 12, name: 'Configure Datacenter PMA Title', children: <ConfigureSdcEmployeeDesignationPmaTitle /> });
    }
    if ((IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_PAYROLL_INFO))) {
      dataCenterTabs.push({ id: 13, name: 'Configure Datacenter Payroll Info', children: <ConfigureDatacenterPayroll /> });
    }
    if ((IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_PROPERTY_SPLIT))) {
      dataCenterTabs.push({ id: 14, name: 'Configure Datacenter Property Configuration', children: <ConfigureDatacenterPropertySplit /> });
    }
    if ((IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_EMPLOYEE_BONUS_PERCENT))) {
      dataCenterTabs.push({ id: 15, name: 'Configure Datacenter Employee Payroll Info', children: <ConfigureDatacenterEmployeeBonusPercent /> });
    }
    if ((IsSectionVisible(SECTIONS.YEAR_END_BONUS, SECTIONS.CONFIGURE_YEARLY_BONUS_TITLE))) {
      yearEndBonusTabs.push({ id: 16, name: 'Configure Employee Bonus By Title', children: <ConfigureBonusAgainstDesignations /> });
    }
    if ((IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CENTERALIZED_AR_ADMIN_PROPERTY_MAPPING))) {
      tabs.push({ id: 17, name: 'Configure AR Admin Property Mapping', children: <ConfigurationARAdminPropertyMapping /> });
    }
    if ((IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_EXPENSE_GROUP_PAYCODE))) {
      tabs.push({ id: 18, name: 'Configure Expense Groups And Pay Codes', children: <ConfigureExpenseGroupAndPayCodes /> });
    }
    if ((IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_EMPLOYEE_TITLE))) {
      tabs.push({ id: 19, name: 'Configure Employee Title', children: <ConfigureEmployeeTitle /> });
    }
    // if ((IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_OVERTIME_TIMESHEET))) {
    if (IsBillingAccountingTabVisible()) {
      tabs.push({ id: 20, name: 'Configure Overtime Timesheet', children: <ConfigureOvertimeTimesheet /> });
    }
    if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_CONTACT_ROLES)) {
      tabs.push({ id: 21, name: 'Configure Contact Roles', children: <ConfigurationContactRoles /> });
    }
    if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.REFRESH_CACHE)) {
      tabs.push({ id: 22, name: 'Refresh Cache', children: <ConfigurationRefreshCache /> });
    }
    this.setState({ tabs, dataCenterTabs, yearEndBonusTabs, selectedMenu: tabs.length > 0 ? tabs[0].id : dataCenterTabs.length > 0 ? dataCenterTabs[0].id : 0, children: tabs.length > 0 ? tabs[0].children : dataCenterTabs.length > 0 ? dataCenterTabs[0].children : '' });
  }

  // Render components based on conditions
  render() {
    const { tabs, selectedMenu, children, dataCenterTabs, yearEndBonusTabs, accessPermissionTerms } = this.state;
    return (
      <div className="row configuration-container" ref={this.myRef}>
        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
          <div className="addwidget-container config-container">
            {IsSectionVisible(SECTIONS.CONFIGURATION) && <>
              <div className="header row">
                {' '}
                <div className="col-xs-11">Configurations</div>
              </div>
              <div className="row widget-content">
                <List
                  component="nav"
                  aria-label="mailbox folders"
                  className="ConfigureMenu"
                >
                  {' '}
                  {
                    tabs.map(tab => {
                      return <>
                        <ListItem
                          button
                          selected={tab.id === selectedMenu}
                          onClick={() => this.setState({ selectedMenu: tab.id, children: tab.children })}
                        >
                          <ListItemText
                            fontSize="small"
                            primary={tab.name}
                          />
                        </ListItem>
                        <Divider />
                      </>;
                    })
                  }
                </List>
              </div>
            </>}

            {IsSectionVisible(SECTIONS.YEAR_END_BONUS) && <>
              <div className="header row">
                {' '}
                <div className="col-xs-11">Year End Bonus</div>
              </div>
              <div className="row widget-content">
                <List
                  component="nav"
                  aria-label="mailbox folders"
                  className="ConfigureMenu"
                >
                  {' '}
                  {
                    yearEndBonusTabs.map(tab => {
                      return <>
                        <ListItem
                          button
                          selected={tab.id === selectedMenu}
                          onClick={() => this.setState({ selectedMenu: tab.id, children: tab.children })}
                        >
                          <ListItemText
                            fontSize="small"
                            primary={tab.name}
                          />
                        </ListItem>
                        <Divider />
                      </>;
                    })
                  }
                </List>
              </div>
            </>}
            {IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION) && <>
              <div className="header row">
                {' '}
                <div className="col-xs-11">Datacenter Configurations</div>
              </div>
              <div className="row widget-content">
                <List
                  component="nav"
                  aria-label="mailbox folders"
                  className="ConfigureMenu"
                >
                  {' '}
                  {
                    dataCenterTabs.map(tab => {
                      return <>
                        <ListItem
                          button
                          selected={tab.id === selectedMenu}
                          onClick={() => this.setState({ selectedMenu: tab.id, children: tab.children })}
                        >
                          <ListItemText
                            fontSize="small"
                            primary={tab.name}
                          />
                        </ListItem>
                        <Divider />
                      </>;
                    })
                  }
                </List>
              </div>
            </>}
            {IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_GROUP_ACCESS_PERMISSION) && selectedMenu === 7 && <>
              <div className="row widget-content">
                <List
                  component="nav"
                  aria-label="mailbox folders"
                  className="ConfigureMenu"
                >
                  {' '}
                  {
                    accessPermissionTerms.map(access => {
                      return <>

                        <div className='row'><span className='col-xs-1 error-text'>{access.accessPermissionTermsLevel}</span> {' '} <span className='col-xs-11'>{access.accessPermissionTermsName} </span></div>
                      </>;
                    })
                  }
                </List>
              </div>
            </>
            }
          </div>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9">
          <div className="addwidget-container row config-container">
            <Paper className={'col-xs-12'}>{children}</Paper>
          </div>
        </div>
      </div>
    );
  }
}
